import { INTRODUCTION_LABEL } from '../introduction';
import { SERVICES_SUBTITLE } from '../services';
import { SERVICES_TITLE } from '../services';
import { ABOUT, CONTACT, ENGLISH, HERO_SUBTITLE, HERO_TITLE,
  HINDI, HOME, HOW_IT_WORKS, LANGUAGE, PARTNER, STATS_CENTRE,
  STATS_CUSTOMER, STATS_FARMERS, STATS_LOCATION, STATS_PARTNERS,
  TEAM, TITLE, NEWS_TITLE, NEWS_SUBTITLE, READ_ARTICLE, STATS_PRODUCTS,
  INPUT, INPUT_DESCRIPTION, INPUT_FEATURE_1, INPUT_FEATURE_2, INPUT_FEATURE_4,
  INPUT_FEATURE_5, INPUT_FEATURE_3, OUTPUT, OUTPUT_DESCRIPTION, OUTPUT_FEATURE_1,
  OUTPUT_FEATURE_2, OUTPUT_FEATURE_3, CROP_ADVISORY, CROP_ADVISORY_DESCRIPTION,
  CROP_ADVISORY_FEATURE_1, CROP_ADVISORY_FEATURE_2, CROP_ADVISORY_FEATURE_3, CROP_ADVISORY_FEATURE_4, CROP_ADVISORY_FEATURE_5,
  FINANCIAL, FINANCIAL_DESCRIPTION, FINANCIAL_FEATURE_1, FINANCIAL_FEATURE_2,
  CONTACT_US, ADDRESS_1, ADDRESS_2, ADDRESS_3, PHONE, EMAIL } from "../../navbar/menu";
import { TESTIMONIAL_DESCRIPTION, TESTIMONIAL_LABEL } from '../testimonial';
import { PARTNER_DESCRIPTION, PARTNER_LABEL } from '../partner';
import { CONTACT_LABEL, QUESTION_FORM_SUBTITLE, QUESTION_FORM_TITLE } from '../contact';

export const hinTranslation = {
  [TITLE]: "फ़्रेशोकार्ट्ज़",
  [LANGUAGE]: "भाषा",
  [ENGLISH]: "अंग्रेजी",
  [HINDI]: "हिंदी",

  [HOME]: "होम",
  [HOW_IT_WORKS]: "कार्य जानकारी",
  [ABOUT]: "अबाउट",
  [PARTNER]: "पार्टनर",
  [TEAM]: "टीम",
  [CONTACT]: "संपर्क",

  [HERO_TITLE]: "भारतीय कृषि का समर्थन",
  [HERO_SUBTITLE]: "हमने अपने किसानों का समर्थन करने और अपने उत्पादों, कृषि विशेषज्ञ और शिक्षा प्लेटफार्मों के साथ अपनी उत्पादकता बढ़ाने के लिए भारतीय कृषि को फिर से तैयार करने के लिए खुद को समर्पित किया है।",

  [STATS_CENTRE]: "किसान केंद्र",
  [STATS_FARMERS]: "किसान",
  [STATS_LOCATION]: "जिले",
  [STATS_CUSTOMER]: "व्यापार ग्राहक",
  [STATS_PARTNERS]: "भागीदार",
  [STATS_PRODUCTS]: "विभिन्न उत्पाद",

  [NEWS_TITLE]:"समाचार उल्लेख",
  [NEWS_SUBTITLE]:"नवीनतम समाचारों में हमारे आशय की जाँच करें ",

  [READ_ARTICLE]: "लेख पढ़ें",

  [INPUT]: 'खाद/ बीज',
  [INPUT_DESCRIPTION]: 'हम बीज, उर्वरक, कीटनाशक आदि प्रदान करते हैं।',
  [INPUT_FEATURE_1]: '💸 पाएं सबसे उचित मूल्य पर कृषी दवाई, खाद और बीज।',
  [INPUT_FEATURE_2]: '🚪 24 घंटे में घर बैठे मुफ्त डिलीवरी।',
  [INPUT_FEATURE_3]: '📞 आप फोन कॉल पर ऑर्डर भी दे सकते हैं।',
  [INPUT_FEATURE_4]: '💯 उत्तम गुणवत्ता के खाद और बीज।',
  [INPUT_FEATURE_5]: '🛒 हमारे पास 10000 से अधिक विभिन्न प्रकार के उत्पाद हैं।',

  [OUTPUT]: 'कृषि उत्पाद विक्रय',
  [OUTPUT_DESCRIPTION]: 'किसान भाई अपने उत्पाद हमारे केंद्र पर आसानी से बेच सकते है।',
  [OUTPUT_FEATURE_1]: '🚚 बाजार से सीधा जुड़ाव।',
  [OUTPUT_FEATURE_2]: '⚖️ सही तौल और भाव एक ही जगह पर।',
  [OUTPUT_FEATURE_3]: '💸 उपज का तुरंत भुगतान।',

  [CROP_ADVISORY]: 'फसल सलाह',
  [CROP_ADVISORY_DESCRIPTION]: 'हमारे उत्कृष्ट कृषि विशेषज्ञ हमेशा आपके लिए हैं।',
  [CROP_ADVISORY_FEATURE_1]: '🔬 मिट्टी की जांच।',
  [CROP_ADVISORY_FEATURE_2]: '👨🏼‍🏭 मुफ्त फसल निरीक्षण।',
  [CROP_ADVISORY_FEATURE_2]: '👨🏼 मुफ्त फसल निरीक्षण।',
  [CROP_ADVISORY_FEATURE_3]: '❗️ कृषि रोग से समन्धित जानकारी ऐवं उपचार।',
  [CROP_ADVISORY_FEATURE_4]: '📕 मुफ्त किसान हेल्पलाइन द्वारा कटाई से बुवाई तक की समस्त जानकारी।',
  [CROP_ADVISORY_FEATURE_5]: '📣 24X7 सहायता केंद्र।',

  [FINANCIAL]: 'फाइनेंस/ लोन',
  [FINANCIAL_DESCRIPTION]: 'फाइनेंस और लोन की सुविधा।',
  [FINANCIAL_FEATURE_1]: '💸 कृषि लोन सहायता।',
  [FINANCIAL_FEATURE_2]: '🚜 कृषि उपकरणों पर वित्तिय सहायता।',


  [CONTACT_US]: "संपर्क करें",
  [ADDRESS_1]: "716,  7th Floor, Elements mall",
  [ADDRESS_2]: "DCM, Ajmer Road, Jaipur",
  [ADDRESS_3]: "Rajasthan 302021",
  [PHONE]: "फ़ोन:",
  [EMAIL]: "ईमेल:",

  [INTRODUCTION_LABEL]: "फ़्रेशोकार्ट्ज़ कैसे काम करता है।",

  [SERVICES_TITLE]: "सेवाएं",
  [SERVICES_SUBTITLE]: "किसानों के साथ हर कदम पर",

  [TESTIMONIAL_LABEL]: "किसान समीक्षा",
  [TESTIMONIAL_DESCRIPTION]: "देखिए दूसरे किसान क्या कहते हैं|",

  [PARTNER_LABEL]: "हमारे पार्टनर",
  [PARTNER_DESCRIPTION]: "हम कृषि क्षेत्र में सबसे अच्छी कंपनियों के साथ काम करते हैं।",


  [CONTACT_LABEL]: "संपर्क करें",
  // [QUESTION_FORM_TITLE]: "Have a Question?",
  // [QUESTION_FORM_SUBTITLE]: "Let us know. Our Team will reach out to you."

};
